module.exports = __webpack_public_path__ + "media/images/vehicles/auflieger-894724de01408e5b5629e0ace5bb6f6c.png";